let tooltips = document.getElementsByClassName('tooltip__content');
let tooltipTriggers = document.getElementsByClassName('tooltip__trigger');

for (let i = 0; i < tooltipTriggers.length; i++) {
    let currentTooltip = tooltips[i];

    // On click hide all other tooltips and show the current.
    tooltipTriggers[i].addEventListener('click', function(e) {
        e.preventDefault();
        hideTooltip();
        currentTooltip.style.visibility = 'visible';
    });

    // On focus hide all other tooltips and show the current.
    tooltipTriggers[i].addEventListener('focus', function(e) {
        hideTooltip();
        currentTooltip.style.visibility = 'visible';
    });

    // On focusout hide tooltip.
    tooltipTriggers[i].addEventListener('focusout', function(e) {
        currentTooltip.style.visibility = 'hidden';
    });
}

// Close tooltips when escape is clicked.
document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
        hideTooltip();
    }
});

// Close tooltips when click outside.
document.addEventListener("click", function (e) {
    if (
        e.target.getAttribute("class") !== null &&
        !e.target
            .getAttribute("class")
            .split(/[ __]+/)
            .includes("tooltip")
    ) {
        hideTooltip();
    }
});

function hideTooltip() {
    for (let i = 0; i < tooltips.length; i++) {
        tooltips[i].style.visibility = 'hidden';
    }
}